import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';
import moment from 'moment';
import Loading from 'components/helpers/loading';
import Helmet from 'react-helmet';
import { DateRangePicker } from 'react-dates';
import DayEditor from './dayEditor';

class Editor extends React.Component {

    constructor(props) {
        super(props);
        var self = this,
            isLoading = false;

        if (!self.props.itinerary) {
            isLoading = true;
            self.props.getItinerary();
        }
        
        self.state = {
            isLoading: isLoading,
            focusedInput: null,
            startDate: null,
            endDate: null
        };
    }

    componentWillReceiveProps(nextProps) {
        var self = this,
            itinerary,
            startDate,
            endDate;

        if (self.state.isLoading && nextProps.itinerary != null) {
            itinerary = nextProps.itinerary;

            if (itinerary.items != null && itinerary.items.length) {
                startDate = moment(itinerary.items[0].date, 'MMMM DD, YYYY');
                endDate = moment(itinerary.items[itinerary.items.length - 1].date, 'MMMM DD, YYYY');
            }

            self.setState({
                isLoading: false,
                itinerary: itinerary,
                startDate,
                endDate
            });
        }
    }

    componentWillMount() {
        var self = this,
            itinerary,
            startDate,
            endDate;

        if (self.props.itinerary != null) {
            itinerary = self.props.itinerary;

            if (itinerary.items != null && itinerary.items.length) {
                startDate = moment(itinerary.items[0].date, 'MMMM DD, YYYY');
                endDate = moment(itinerary.items[itinerary.items.length - 1].date, 'MMMM DD, YYYY');
            }

            self.setState({
                itinerary: itinerary,
                startDate,
                endDate
            });
        }
    }

    onDatesChanged = ({ startDate, endDate}) => {
        var self = this,
            itinerary = self.state.itinerary,
            duration = moment(endDate).diff(startDate, 'days') + 1,
            currentDuration,
            i, len;

        if (!itinerary) {
            itinerary = {};
        }

        if (!itinerary.items) {
            itinerary.items = [];
        }

        currentDuration = itinerary.items.length;

        if (currentDuration > 0 &&
            duration !== currentDuration &&
            !window.confirm('Changing the date range will cause some of your on plans to be be lost. Continue?')) {
            return false;
        }

        if (duration > currentDuration) {
            for (i = 0, len = (duration - currentDuration); i < len; i++) {
                itinerary.items.push({});
            }
        }
        else if (duration < currentDuration) {
            itinerary.items.splice(duration);
        }

        _.each(itinerary.items, (item, index) => {
            item.date = startDate.clone().add(index, 'days').format('MMMM D, YYYY');
        });

        self.setState({
            startDate,
            endDate,
            itinerary: itinerary
        });
    }

    onDateFocusChange = (focusedInput) => {
        var self = this;

        self.setState({
            focusedInput
        });
    }

    addDay = (e) => {
        var self = this,
            endDate = self.state.endDate,
            itinerary = self.state.itinerary,
            newDay;

        e.preventDefault();

        if (!itinerary) {
            itinerary = {};
        }

        if (!itinerary.items) {
            itinerary.items = [];
        }

        newDay = {
            date: moment(endDate.add(1, 'day')).format('MMMM D, YYYY')
        };

        itinerary.items.push(newDay);

        self.setState({
            endDate: endDate,
            itinerary: itinerary
        }, () => {
            self.refs.bottom.scrollIntoView(true);
        });
    }

    updateItineraryItem = (date, detail) => {
        var self = this,
            day = { ...detail, date },
            itinerary,
            items,
            i, len;

        itinerary = self.state.itinerary;
        items = self.state.itinerary.items;

        for (i = 0, len = items.length; i < len && items[i].date != date; i++) { }
        i < len ? items[i] = day : items.push(day);

        itinerary.items = items;

        self.setState({ 
            itinerary: itinerary
        });
    }

    updateTitle = (title) => {
        var self = this,
            itinerary = self.state.itinerary || {};

        itinerary.title = title;

        self.setState({
            itinerary: itinerary
        });
    }

    save = (e) => {
        var self = this;

        e.preventDefault();

        self.setState({
            isLoading: true
        });

        self.props.setItinerary(self.state.itinerary).then(data => {
            if (data.payload.errorCode) {
                self.setState({
                    errorMessage: data.payload.errorMessage,
                    isLoading: false
                });
            }
            else {
                browserHistory.push('/itinerary');
            }
        })
    }

    render () {
        var self = this,
            itinerary = self.props.itinerary || {},
            startDate;

        if (self.state.isLoading) {
            return <Loading />;
        }

        return (
            <div className="page-container page-container-responsive">
                <Helmet title="Walkabout: Edit Trip" />
                <h1 className="page-title">Edit Trip</h1>
                
                <form className="page-content" style={ { marginBottom: '60px' } }>
                    <div className="form-group">
                        <label htmlFor="tripTitle">Trip Title</label>
                        <input type="text" className="form-control" id="tripTitle" aria-describedby="tripTitleHelp" placeholder="ex. Australia Spring Break Trip"
                               defaultValue={ itinerary.title }
                               onChange={ (e) => self.updateTitle(e.target.value) } />
                        <small id="tripTitleHelp" className="form-text text-muted">Enter a succint name for your trip</small>
                    </div>

                    <div className="form-group">
                        <label htmlFor="tripStart" style={ { display: 'block' } }>Date Range</label>
                        <DateRangePicker id="tripStart" 
                                         aria-describedby="tripStartHelp"
                                         onDatesChange={ self.onDatesChanged }
                                         onFocusChange={ self.onDateFocusChange }
                                         focusedInput={ self.state.focusedInput }
                                         startDate={ self.state.startDate }
                                         endDate={ self.state.endDate } />
                        <small id="tripStartHelp" className="form-text text-muted">Note that changing the start date of your trip will change the dates of all of your itinerary items</small>
                    </div>

                    <div className="form-group">
                        <h4>Itinerary</h4>

                        <ul className="editor-day-list">
                            {
                                itinerary != null && Array.isArray(itinerary.items) ?
                                    itinerary.items.map(item => <DayEditor key={ item.date } day={ item } onChange={ (detail) => self.updateItineraryItem(item.date, detail) } />)
                                    : null
                            }
                        </ul>
                    </div>

                    <div ref="bottom"></div>
                </form>

                <footer className="footer text-muted">
                    <div className="container editor-controls">
                        <button type="button" className="btn btn-primary" onClick={ self.save }>
                            <i className="fa fa-save"></i><span className="hidden-md-down">&nbsp;Save</span>
                        </button>

                        <button type="button" className="btn btn-primary" onClick={ self.addDay }>
                            <i className="fa fa-plus"></i><span className="hidden-md-down">&nbsp;Add a day</span>
                        </button>
                    </div>
                </footer>
            </div>
        );
    }
};

export default Editor;


// WEBPACK FOOTER //
// ./src/app/components/editor/editor.jsx